import { colors } from './brand';

/**
 * Predefined gradient presets for announcements using brand colors
 * Each gradient is defined as an array of color hex codes
 */
export const announcementGradients = {
  default: {
    name: 'Default Teal',
    colors: [colors.primary.teal, colors.primary.darkTeal, colors.secondary.slate],
    description: 'Classic teal gradient'
  },
  coral: {
    name: 'Coral Sunset',
    colors: [colors.secondary.coral, colors.tertiary.orange, colors.secondary.slate],
    description: 'Warm coral to orange'
  },
  green: {
    name: 'Fresh Green',
    colors: [colors.secondary.green, colors.secondary.olive, colors.primary.teal],
    description: 'Vibrant green gradient'
  },
  ocean: {
    name: 'Ocean Blue',
    colors: [colors.primary.teal, colors.secondary.lightTeal, colors.tertiary.cyan],
    description: 'Cool ocean tones'
  },
  sunset: {
    name: 'Sunset',
    colors: [colors.tertiary.orange, colors.secondary.coral, colors.primary.darkTeal],
    description: 'Warm sunset colors'
  },
  forest: {
    name: 'Forest',
    colors: [colors.primary.darkTeal, colors.secondary.olive, colors.secondary.green],
    description: 'Natural forest tones'
  },
  slate: {
    name: 'Slate Blue',
    colors: [colors.secondary.slate, colors.tertiary.darkSlate, colors.primary.black],
    description: 'Deep slate gradient'
  },
  vibrant: {
    name: 'Vibrant',
    colors: [colors.primary.teal, colors.tertiary.cyan, colors.secondary.coral],
    description: 'Bold and vibrant'
  },
} as const;

export type GradientPreset = keyof typeof announcementGradients;

/**
 * Get gradient CSS string for a given preset
 */
export function getGradientStyle(preset: GradientPreset | string): string {
  const gradient = announcementGradients[preset as GradientPreset];
  if (!gradient) {
    // Fallback to default
    const defaultGradient = announcementGradients.default;
    return `linear-gradient(to right, ${defaultGradient.colors.join(', ')})`;
  }
  return `linear-gradient(to right, ${gradient.colors.join(', ')})`;
}

/**
 * Get all available gradient options for select dropdown
 */
export function getGradientOptions() {
  return Object.entries(announcementGradients).map(([key, value]) => ({
    value: key,
    label: value.name,
    description: value.description,
    colors: value.colors
  }));
}

